import { render } from "./user-center.vue?vue&type=template&id=82e8fd50&scoped=true"
import script from "./user-center.vue?vue&type=script&lang=js"
export * from "./user-center.vue?vue&type=script&lang=js"

import "./user-center.vue?vue&type=style&index=0&id=82e8fd50&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82e8fd50"]])

export default __exports__